/**
 * `useColumnMeta` — memoized inference for every column.
 *
 * Heavy work (full-row scan for cardinality + categorical palette) is
 * memoized on (columns, rows reference). Callers should keep their
 * `rows` reference stable across renders to avoid re-inference.
 */

import { useMemo } from 'react';
import type { ColumnHints, ColumnMeta } from './types';
import { inferColumnMeta } from './fieldTypes';

export function useColumnMeta(
  columns: string[],
  rows: any[][],
  hints?: ColumnHints,
): ColumnMeta[] {
  return useMemo(() => {
    return columns.map((name, idx) => inferColumnMeta(name, idx, rows, hints));
    // hints is shallow-compared via JSON for stability.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [columns, rows, JSON.stringify(hints?.columnTypes || {}), JSON.stringify(hints?.columnSemantics || {})]);
}
